import { Badge } from "antd";
import React from "react";
import twizzLogo from "../../assets/images/logo512.webp";
import { CREATOR } from "../../helpers/constant";
import useUserOnlineHook from "../../helpers/hooks/useUserOnlineHook";
import { authService } from "../../services";
import AvatarComponent from "../AvatarComponent";
import FanAvatarComponent from "../FanAvatarComponent";

type props = {
  // userId?: string;
  avatar?: string;
  name?: string;
  username?: string;
  isPublicTL?: boolean;
};

const ConversationAvatarComponent: React.FC<props> = ({ avatar, name, username, isPublicTL = false }) => {
  const isOnline = useUserOnlineHook(username);
  const canShowOnlineStatus = authService.getRole() === CREATOR;
  if (avatar) {
    if (isOnline && canShowOnlineStatus) {
      return (
        <Badge dot={true} color="#00ff18" offset={[-15, 64]} className="avatarOnlineDot">
          <AvatarComponent image={avatar} size={72} />
        </Badge>
      );
    } else {
      return <AvatarComponent image={avatar} size={72} />;
    }
  } else {
    if (isOnline && canShowOnlineStatus) {
      return (
        <Badge dot={true} color="#00ff18" offset={[-11, 60]} className="avatarOnlineDot">
          <FanAvatarComponent name={name} size={72} />
        </Badge>
      );
    } else {
      console.log("isPublicTL", isPublicTL);
      if (isPublicTL) {
        return <AvatarComponent image={twizzLogo} size={72} />;
      }
      return <FanAvatarComponent name={name} size={72} />;
    }
  }
};

export default ConversationAvatarComponent;
